const Auth = {
    isAuthenticated() {
        return localStorage.getItem('auth') === 'true';
    },
    authenticate() {
        localStorage.setItem('auth', true);
    },
    signout() {
        localStorage.setItem('auth', false);
    },
    isSuperAdminDashboard(){
        return localStorage.getItem('superAdmin') === 'true';
    }
};

export default Auth;




// WEBPACK FOOTER //
// ./src/Auth.jsx